import { useEffect, useState } from "react";
import { useHttpRequest } from "../../hooks/useHttpRequest";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import VoiceElements from "./VoiceElements";
import { setOnCall } from "../../app/userState/userStateSlice";
import ringtone from "../../../public/sound/ringtone.mp3";
import useSound from "use-sound";
import { useNavigate } from "react-router-dom";
const MainPlugin = () => {
    const { incomingMessage, callState, mediaServerMap } = useAppSelector((state) => state.call);
    const { user } = useAppSelector((state) => state.auth);
    const [meetingStatus, setMeetingStatus] = useState("");
    const [customerName] = useState("");
    const { sendRequest } = useHttpRequest();
    const dispatch = useAppDispatch()
    const [mediaUrl, setMediaUrl] = useState(process.env.REACT_APP_WSDASH_ADDRESS as string)
    const [play, { stop }] = useSound(ringtone);
    const createRoom = async () => {

        if (user && incomingMessage.username !== "" && incomingMessage.username) {

            dispatch(setOnCall("Receive SIP Call"))
            const baseUrl = String(process.env.REACT_APP_CHAT_SERVICE);
            const payload = {
                deviceId: user.deviceId,
                userName: incomingMessage.username + "_SIP",
                fullName: incomingMessage.username,
                serviceGroupId: "1",
                tag: "generic",
                agentUserName: user.username,
                tenantId: user.tenantId,
                channel: "ARSISIP",
                sessionId: incomingMessage.session_id
            }
            await sendRequest({
                baseUrl: baseUrl,
                url: `JoinRoomAll`,
                method: "post",
                body: payload,

            });
        }

    }
    const tryMapRoomToCustomer = async () => {
        const baseUrl = String(process.env.REACT_APP_CUSTOMER_SERVICE);
        const payload = { customer_id: "", room_id: incomingMessage.username + "_SIP", full_name: incomingMessage.username, account_type: "PhoneNumber", account: incomingMessage.username }
        await sendRequest({
            baseUrl: baseUrl,
            url: `customer/mapping`,
            method: "post",
            body: payload
        });



    }
    const navigate = useNavigate();
    const checkMessageType = () => {
        if (!callState.isCalling && (meetingStatus === "" || meetingStatus.includes("missing") || meetingStatus === "close")) {
            if (incomingMessage.msg_type === "INCOMINGCALL") {
                const path = window.location.pathname;
                if (!path.includes("leads")) { navigate("/leads") }
                setMediaUrl(process.env.REACT_APP_WSDASH_ADDRESS as string)
                setMeetingStatus(`waiting-voice-sip`)
                createRoom().catch((ex) => { console.log("error", ex) })
                tryMapRoomToCustomer().catch((ex) => { console.log("error", ex) })
            }
        }
        else
            if (incomingMessage.msg_type === "INCOMINGCALL") {
                setMediaUrl(process.env.REACT_APP_WSDASH_ADDRESS as string)
                setMeetingStatus(`meeting-voice-sip`)
            }

        if (incomingMessage.msg_type === "CANCELEDCALL")
            stop()
    }
    useEffect(() => {
        if (user) {
            if (incomingMessage?.call_id !== undefined) {
                checkMessageType()
            }
        }
    }, [incomingMessage])
    useEffect(() => {
        if (callState.isCalling && incomingMessage.call_id === undefined) {
            setMeetingStatus(`meeting-voice-sip`)
            if (mediaServerMap.length > 0) {
                const selectedMediaServer = mediaServerMap.filter(x => x.lastnumber == callState.callDestination.slice(-1))
                if (selectedMediaServer.length > 0) {
                    setMediaUrl(`wss://${selectedMediaServer[0].url}:1338`)
                }
            }
        }
    }, [callState])
    useEffect(() => {
        if (meetingStatus.includes("waiting"))
            play()
        else if (meetingStatus.includes("missing") || meetingStatus.includes("meeting"))
            stop()
    }, [meetingStatus])
    return (
        <>
            {(meetingStatus.includes("waiting") || meetingStatus.includes("missing") || meetingStatus.includes("meeting")) &&
                <VoiceElements mediaUrl={mediaUrl} meetingStatus={meetingStatus} customerName={customerName} setMeetingStatus={(status) => {
                    setMeetingStatus(status)
                }}></VoiceElements>
            }
        </>
    );
}

export default MainPlugin;
